import { createSvgIcon } from '@mui/material';

export const PayoutIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M4 20c-.55 0-1.02083-.1958-1.4125-.5875C2.19583 19.0208 2 18.55 2 18V6c0-.55.19583-1.02083.5875-1.4125C2.97917 4.19583 3.45 4 4 4h16c.55 0 1.0208.19583 1.4125.5875C21.8042 4.97917 22 5.45 22 6v12c0 .55-.1958 1.0208-.5875 1.4125C21.0208 19.8042 20.55 20 20 20H4Zm0-8h16V8H4v4Z"
    />
  </svg>,
  'PayoutIcon',
);
